{
	"logout": "Logout",
	"org": "Organization",
	"place": "Place",
	"event": "Event",
	"language": "Language"
}
